import Metadata from '../../../requests/apa/Metadata';
import DeviceStorage from '../../../components/DeviceStorage/DeviceStorage';
import { AAF_CONTENT_IS_NPVR, AAF_CONTENT_IS_CATCHUP } from '../../../AAFPlayer/constants';
/**
 Video controls
 **/
export const CONTROL_RECORDING = 'recording';
export const CONTROL_BACKWARD = 'backward';
export const CONTROL_FORWARD = 'forward';
export const CONTROL_TS_BACKWARD = 'ts_backward';
export const CONTROL_TS_FORWARD = 'ts_forward';
export const CONTROL_SPEED_BACKWARD = 'speed_backward';
export const CONTROL_SPEED_FORWARD = 'spedd_forward';
export const CONTROL_PLAY = 'play';
export const CONTROL_PAUSE = 'pause';
export const CONTROL_EPG = 'epg';
export const CONTROL_LANGUAGE = 'language';
export const CONTROL_SERIE = 'episode';
export const CONTROL_EXIT = 'salir';
export const CONTROL_FAVORITE = 'favorite';
export const CONTROL_UNFAVORITE = 'unfavorite';

export const videoControlWidth = '43';
export const videoControlHeight = '43';

export const videoControlWidthOnFocus = '53';
export const videoControlHeightOnFocus = '53';


export const sliderBallHeight = '43';

const skip_seconds = Metadata.get('skip_seconds', 60);



export const getBackwardTimeByStreamtypeTS = (stream_content_type = '', fromSlider = false) =>{
    const metadata = metadataSkipSecondsTS();
    
    if(stream_content_type && (typeof metadata  === 'object') && metadata[stream_content_type]){
        return metadata[stream_content_type];
    }else{
        // SE DEJAN LOS DEFAULT;
        if(fromSlider){
            if(stream_content_type === AAF_CONTENT_IS_NPVR || stream_content_type === AAF_CONTENT_IS_CATCHUP){
                return playerSettings.slideTime;
            }
        }else{
            return playerSettings.backwardTime_timeshift;
        }

        
    }

}

export const getForwardTimeByStreamtypeTS = (stream_content_type = '', fromSlider= false) =>{
    const metadata = metadataSkipSecondsTS();
    
    if(stream_content_type && (typeof metadata  === 'object') && metadata[stream_content_type]){
        return metadata[stream_content_type];
    }else{
        // SE DEJAN LOS DEFAULT;
        if(fromSlider){
            if(stream_content_type === AAF_CONTENT_IS_NPVR || stream_content_type === AAF_CONTENT_IS_CATCHUP ){
                return playerSettings.slideTime;
            }
        }else{            
            return playerSettings.forwardTime_timeshift;
        }
    }
}

const metadataSkipSecondsTS = () =>{
    const skip_seconds_ts =  Metadata.get('skip_seconds_timeshift', '{"default":{"content_is_tv":10, "content_is_startover":10}}');
    const objectMeta = JSON.parse(skip_seconds_ts);
    var _region = DeviceStorage.getItem('region');
    const value = objectMeta[_region] ? objectMeta[_region] : objectMeta['default'];
    return value;
}



export const playerSettings = {
  slideTime: skip_seconds / 4,
  backwardTime: skip_seconds / 6, // 10 hacía atrás
  stepBackwardTime: skip_seconds / 4, // 15 hacía atrás
  fastBackwardTime: skip_seconds / 2, // 30 hacía atrás
  forwardTime: skip_seconds / 6, // 10 hacía adelante
  stepForwardTime: skip_seconds / 4, // 15 hacía adelante
  fastForwardTime: skip_seconds / 2, // 30 hacía adelante
  inactivityTime: skip_seconds / 3,

    // Timeshift
    backwardTime_timeshift: skip_seconds * 3, // 3 hacía atrás
    stepBackwardTime_timeshift: skip_seconds * 10, // 10 Mins hacía atrás
    forwardTime_timeshift: skip_seconds * 3, // 3 Mins hacía adelante
    stepForwardTime_timeshift: skip_seconds * 10, // 10 Mins hacía adelante
    slideTime_timeshift: skip_seconds * 3, // intervalos de 3 mins forward/backward

    getBackwardTimeByStreamtypeTS: getBackwardTimeByStreamtypeTS,
    getForwardTimeByStreamtypeTS: getForwardTimeByStreamtypeTS
};



// WEBPACK FOOTER //
// ./src/playerDomain/components/common/constants.js